import { useEffect } from 'react';
import { trackPageView } from '../../utils/analytics';
import HomePageSchema from '../../components/HomePageSchema';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import ChooserIntro from './components/ChooserIntro';
import PersonalPath from './components/PersonalPath';
import BusinessPath from './components/BusinessPath';
import IdentityPath from './components/IdentityPath';
import CheckoutTutorial from './components/CheckoutTutorial';
import Endorsement from './components/Endorsement';
import MLMElephant from './components/MLMElephant';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import StickyBottomBar from './components/StickyBottomBar';

export default function HomePage() {
  useEffect(() => {
    // Track page view
    trackPageView('home');

    // Handle anchor scrolling after navigation
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0a1628]">
      <HomePageSchema />
      <Hero />
      <Problem />
      <Solution />
      <ChooserIntro />
      <PersonalPath />
      <BusinessPath />
      <IdentityPath />
      <CheckoutTutorial />
      <Endorsement />
      <MLMElephant />
      <FAQ />
      <FinalCTA />
      <Footer />
      <StickyBottomBar />
    </div>
  );
}